import moment from 'moment';
import Title from '@/components/ui/title/title.jsx';
import Util from "@/lib/Util.jsx";


const getIconForIncident = (type) => {
  switch (type) {
    case 'Acidente':
      return 'bi-exclamation-triangle text-danger';
    case 'Defeito Mecânico':
      return 'bi-wrench text-warning';
    case 'Vandalismo e depreciação':
      return 'bi-slash-circle text-dark';
    case 'Início da operação':
      return 'bi-play-circle text-success';
    case 'Término da operação':
      return 'bi-stop-circle text-danger';
    default:
      return 'bi-info-circle text-primary';
  }
};

export default function HistoryTimeline({vehicle}) {
  const {status, incidents, maintenances, manufactureYear, operationStartDate, operationEndDate} = vehicle;
  
  // Combinar incidentes e manutenções em uma única timeline e ordenar
  const timelineEvents = [
    ...(incidents || []).map(inc => ({...inc, isMaintenance: false})),
    ...(maintenances || []).map(maint => ({...maint, isMaintenance: true, type: 'Manutenção'})),
  ];
  // .map(inc => ({...inc, date: inc.date.replace("Z", "-03:00")}))
  
  if (operationStartDate) {
    const descriptionStr = (
      Util.diffToHuman(
        moment(),
        Util.safeParseDate(operationStartDate),
        true
      )
    )
    
    timelineEvents.push({
      id: 'init',
      vehicleId: vehicle.id,
      date: operationStartDate,
      description: `Entrada do veículo modelo ${vehicle.modelYear} fabricado em ${manufactureYear} na operação da frota do operador "${vehicle.operator.name}" - ${descriptionStr.trim()}.`,
      type: "Início da operação",
      isMaintenance: false
    });
  } else {
    // Início da operação baseado no ano de fabricação
    timelineEvents.push({
      id: 'init-est',
      vehicleId: vehicle.id,
      date: `${manufactureYear}-01-01T00:00:00-03:00`,
      description: `Início estimado da operação do veículo modelo ${vehicle.modelYear} fabricado em ${manufactureYear}.`,
      type: "Início da operação",
      isMaintenance: false
    });
  }
  
  if (operationEndDate && ["DESATIVADO", "SUBSTITUÍDO"].map(s => s.toLowerCase()) .includes(status.toLowerCase())) {
    const removeMarcDiff = (str) => str.replace(/(há)|(em)/g, "");
    const descriptionStr = removeMarcDiff(
      Util.diffToHuman(
        Util.safeParseDate(operationEndDate),
        Util.safeParseDate(operationStartDate),
        true
      )
    )
    
    timelineEvents.push({
      id: 'end',
      vehicleId: vehicle.id,
      date: operationEndDate,
      description: `Saída do veículo do sistema. O carro ficou ${descriptionStr.trim()} em operação.`,
      type: "Término da operação",
      isMaintenance: false
    });
  }
  
  timelineEvents.sort((a, b) => new Date(b.date) - new Date(a.date));
  
  // Se for o de finalização da operação, tem que ser exibido ANTES dos demais
  timelineEvents.sort((a, b) => {
    if (a.id === "end" && b.id !== "end") return -1;
    if (a.id !== "end" && b.id === "end") return 1;
    return 0;
  });
  
  return (
    <section id="historico">
      <Title type="h2" title="Histórico do Veículo" classX="text-body-secondary mb-4"/>
      {timelineEvents.length === 0 ? (
        <p className="text-body">Nenhum evento registrado no histórico deste veículo.</p>
      ) : (
        <div className="position-relative ms-3 pb-2">
          {timelineEvents.map((event, index) => (
            <div key={event.id || index} className="position-relative pb-4 ps-4">
              {index !== timelineEvents.length - 1 && (
                <div
                  className="position-absolute bg-primary-subtle"
                  style={{width: '2px', left: '-1px', top: '15px', height: '100%', zIndex: 0}}
                />
              )}
              <div
                className="position-absolute bg-white border border-2 border-primary-subtle rounded-circle d-flex justify-content-center align-items-center"
                style={{width: '30px', height: '30px', left: '-15px', top: '0', zIndex: 1}}
              >
                <i className={`bi ${event.isMaintenance ? 'bi-tools text-success' : getIconForIncident(event.type)} fs-6`}></i>
              </div>
              <div className="bg-body-tertiary p-3 rounded">
                <h6 className="fw-bold mb-1">{Util.renderText(event.type)}</h6>
                <span className="text-muted d-block mb-2">
                  <i className="bi bi-calendar me-1"></i>
                  {Util.renderText(Util.diffToHuman(Util.safeParseDate(event.date)))}
                </span>
                <p className="mb-0 text-body">{Util.renderText(event.description)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
